// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#rose-chart{width:30%;height:100%;background-color:rgba(6,30,93,.5);border-top:2px solid rgba(1,153,209,.5);box-sizing:border-box}#rose-chart .rose-chart-title{height:50px;font-weight:700;text-indent:20px;font-size:20px;display:flex;align-items:center}#rose-chart .dv-charts-container{height:calc(100% - 50px)}", ""]);
// Exports
module.exports = exports;
